import { render, staticRenderFns } from "./audioPlay1.vue?vue&type=template&id=196243f8&scoped=true&"
import script from "./audioPlay1.vue?vue&type=script&lang=js&"
export * from "./audioPlay1.vue?vue&type=script&lang=js&"
import style0 from "./audioPlay1.vue?vue&type=style&index=0&id=196243f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196243f8",
  null
  
)

export default component.exports